import { connect } from 'react-redux';
import { Flask as Component } from './Flask';
import {
  pushInteractions,
  setHeld,
  setHeldObject,
  incFlask,
  decFlask,
  setSolutionInGelBox,
  isPouring,
  setFlaskHeld,
  setMoveMenu,
  showMoveMenu,
  setFlaskControlVisibility,
  hideAllControls,
  createFlask
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("flask") &&
    state.notebook.protocolSection.scene.apparatus.flask.some(
      flask => flask.id === ownProps.id
    )
  ) {
    return {
      id: ownProps.id,
      volume: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].volume,
      solutions: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].solutions,
      type: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].type,
      moveMenuDisplay: state.notebook.protocolSection.scene.apparatus.moveMenu.display,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].controlsVisible,
      interactionProps: {
        gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    createFlask: (data) => {
      dispatch(createFlask(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    incFlask: (data) => {
      dispatch(incFlask(data))
    },
    decFlask: (data) => {
      dispatch(decFlask(data))
    },
    setSolutionInGelBox: (data) => {
      dispatch(setSolutionInGelBox(data))
    },
    isPouring: (data) => {
      dispatch(isPouring(data))
    },
    setFlaskHeld: (data) => {
      dispatch(setFlaskHeld(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setFlaskControlVisibility: (data) => {
      dispatch(setFlaskControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },

    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },

  };
}

export const Flask = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
